// ---------------------------------------------------------------------------
// When the CarPlay card may appear (PLE-13).
//
// It used to open 3s after the map on the very first launch, stacked on the
// location dialog and the intro strip, and dismissing it fires the speech and
// microphone prompts — so one card became three layers. Decided Sep 30: it
// waits until the person has driven. A finished drive (arrived or not), or a
// CarPlay connection, makes it eligible; the card itself still waits for a
// calm moment (see CarPlayAnnouncement).
//
// A plain module rather than part of the component so carplayBridge can mark
// a connection without importing React UI.
// ---------------------------------------------------------------------------

const ELIGIBLE_KEY = "pleasant.carplayAnnounce.eligible";

export const isCarplayCardEligible = (): boolean => {
  try {
    return localStorage.getItem(ELIGIBLE_KEY) === "1";
  } catch {
    return false;
  }
};

export const markCarplayCardEligible = (): void => {
  try {
    localStorage.setItem(ELIGIBLE_KEY, "1");
  } catch {
    /* storage unavailable — the card simply waits */
  }
};
